import { extendObj } from '@golden/utils';
import { createBaseModule, createMemoService, createTrunkService, createSocket, createQRCodeService, createBaseActivityService, createExchangeRateService, createConfigService, getDefaultInterceptor } from '@golden/gdk-base';
import { createCommonService } from './service/CommonService';
import { createAuthService } from './service/AuthService';
import { createUserService } from './service/UserService';
import { createAgentService } from './service/AgentService';
import { createRealTimeService } from './service/RealTimeService';
import { createDomainService } from './service/DomainService';
import { createReportService } from './service/ReportService';
import { createAgentSocketService } from './service/SocketService';
import { createAnnouncementService } from './service/AnnouncementService';
import { createAgentDepositService } from './service/AgentDepositService';
import { createWalletService } from './service/WalletService';
import { createNotificationService } from './service/NotificationService';
export function createAgentModule(baseURL, wsURL, timeout, lang, customInterceptor = getDefaultInterceptor) {
    const socket = createSocket(wsURL, { transports: ['websocket', 'polling'], path: '/ws/socket.io', autoConnect: false });
    const baseModule = createBaseModule(baseURL, timeout, lang, customInterceptor);
    const trunk = createTrunkService(baseModule.isLoginSubject);
    const auth = createAuthService(baseModule.api, trunk, baseModule.isLoginSubject);
    const agent = createAgentService(baseModule.api, trunk);
    const noRealTimeAgentModule = extendObj(baseModule, {
        common: createCommonService(baseModule.api),
        auth,
        trunk,
        agent,
        memo: createMemoService(baseModule.api),
        user: createUserService(baseModule.api, trunk),
        domain: createDomainService(baseModule.api),
        report: createReportService(baseModule.api),
        announcement: createAnnouncementService(baseModule.api, trunk),
        notification: createNotificationService(baseModule.api),
        agentDeposit: createAgentDepositService(baseModule.api),
        wallet: createWalletService(baseModule.api),
        qrcode: createQRCodeService(baseModule.api),
        exchangeRate: createExchangeRateService(baseModule.api),
        activity: createBaseActivityService(baseModule.api, true),
        config: createConfigService(baseModule.api, trunk)
    });
    const realTimeService = createRealTimeService(baseModule.api, trunk, noRealTimeAgentModule);
    const agentModule = extendObj(noRealTimeAgentModule, {
        socket: createAgentSocketService(baseModule.api, socket, trunk, agent, auth, realTimeService),
        get legacyMode() {
            return realTimeService.isEnable;
        },
        set legacyMode(value) {
            realTimeService.isEnable = value;
        }
    });
    agentModule.legacyMode = true;
    return agentModule;
}
//# sourceMappingURL=AgentModule.js.map